import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {withStyles, WithStyles} from '@material-ui/core';
import {DomainLookup} from '../../containers';
import {ContainerWithListAndForm, RecentDomainsLookupsTable} from '../../components';

import {CategoryHistoryResult, DomainLookupResult, DomainLastReport} from '../../types/Lookup';
import {
  lookupDomainCategories,
  getDomainCategoryHistory,
  getRecentDomains,
  getDomainLastReport,
} from './action';
import {QUERY_PARAMS_OPTIONS} from '../../constants';

import {style} from './style';

function LookupTool({classes}: WithStyles<typeof style>) {
  const dispatch = useDispatch();

  const [recentDomains, setRecentDomains] = useState<string[]>([]);
  const [lookupDomainResult, setLookupDomainResult] = useState<DomainLookupResult | undefined>();
  const [categoryHistory, setCategoryHistory] = useState<CategoryHistoryResult>([]);
  const [domainLastReport, setDomainLastReport] = useState<DomainLastReport | undefined>();
  const [domainSearch, setDomainSearch] = useState('');

  const lookupDomain = (domain: string) => {
    lookupDomainCategories(
      domain,
      (result) => setLookupDomainResult(result),
    )(dispatch);
    getDomainCategoryHistory(
      domain,
      (result) => setCategoryHistory(result),
    )(dispatch);
    getDomainLastReport(
      domain,
      (result) => setDomainLastReport(result),
    )(dispatch);
    setDomainSearch(domain);
  };

  useEffect(() => {
    getRecentDomains(
      (result) => setRecentDomains(result.map((d) => d.domainName)),
    )(dispatch);
  }, [lookupDomainResult]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const domain = params.get(QUERY_PARAMS_OPTIONS.LOOKUP_DOMAIN);
    if (domain) {
      lookupDomain(domain);
    }
  }, []);

  return (
    <ContainerWithListAndForm
      customClassname={classes.container}
      list={(
        <RecentDomainsLookupsTable
          recentDomains={recentDomains}
          lookupDomain={lookupDomain}
        />
      )}
      form={(
        <DomainLookup
          lookupDomain={lookupDomain}
          categoryHistory={categoryHistory}
          lookupDomainResult={lookupDomainResult}
          domainLastReport={domainLastReport}
          domainSearch={domainSearch}
          setDomainSearch={setDomainSearch}
        />
      )}
    />
  );
}

export default withStyles(style)(LookupTool);
